import React from "react";
import { MessageCircle, Shield, Network } from "lucide-react";

const FEATURE_CARDS = [
  {
    title: "Ask TeamGrid – Your AI Productivity Assistant",
    body: "A modern Time Doctor alternative that lets you chat with your data to get instant, organization-wide performance insights without digging through reports.",
    icon: MessageCircle,
    iconBgClass: "bg-[rgba(242,103,58,0.12)]",
    iconColorClass: "text-[#F2673A]",
    titleClass: "text-[#1E293B]",
  },
  {
    title: "Privacy-First by Design",
    body: "TeamGrid delivers actionable insights without monitoring screens or recording inputs. A Time Doctor alternative built for transparency and trust.",
    icon: Shield,
    iconBgClass: "bg-[rgba(100,116,139,0.12)]",
    iconColorClass: "text-[#475569]",
    titleClass: "text-[#0F766E]",
    imageSrc: "/3rd_card_image.webp",
  },
  {
    title: "Organizational Intelligence",
    body: "Uncover team inefficiencies, identify improvement areas, and make better decisions all in real time, with no micromanagement.",
    icon: Network,
    iconBgClass: "bg-[rgba(0,209,193,0.12)]",
    iconColorClass: "text-[#0D9488]",
    titleClass: "text-[#0F766E]",
  },
];

const InnerContent = () => (
  <div className="w-full max-w-[1100px] mx-auto flex flex-col items-center gap-12">
    {/* Badge */}
    <div className="inline-flex items-center justify-center rounded-full bg-[rgba(0,209,193,0.08)] border border-[rgba(0,209,193,0.25)] px-5 py-2">
      <span
        className="text-[13px] font-semibold uppercase tracking-[0.65px] text-[#00D1C1]"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        KEY FEATURES
      </span>
    </div>

    {/* Heading */}
    <h2
      className="font-bold text-center text-[#0F172A] tracking-[-0.02em] max-w-[800px]"
      style={{
        fontFamily: "Inter, sans-serif",
        fontSize: "clamp(1.75rem, 4vw, 48px)",
        lineHeight: 1.2,
      }}
    >
      Why Teams Are Switching
    </h2>

    {/* Subtitle */}
    <p
      className="text-center text-[#64748B] font-medium max-w-[560px]"
      style={{
        fontFamily: "Inter, sans-serif",
        fontSize: "clamp(1rem, 1.5vw, 20px)",
        lineHeight: 1.5,
      }}
    >
      Ask TeamGrid – Your AI Workforce Assistant
    </p>

    {/* Feature cards - 3 columns */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
      {FEATURE_CARDS.map((card, i) => {
        const Icon = card.icon;
        return (
          <div
            key={i}
            className="bg-white border border-[#E5E7EB] rounded-[12px] p-6 flex flex-col items-start gap-4 shadow-[0_1px_3px_rgba(0,0,0,0.06)]"
          >
            <div
              className={`w-12 h-12 rounded-[10px] flex items-center justify-center flex-shrink-0 overflow-hidden ${card.iconBgClass}`}
            >
              {card.imageSrc ? (
                <img src={card.imageSrc} alt={card.title || "Feature"} className="w-full h-full object-contain" />
              ) : (
                <Icon className={`w-6 h-6 ${card.iconColorClass}`} strokeWidth={2} />
              )}
            </div>
            <h3
              className={`font-bold text-[18px] leading-[1.35] ${card.titleClass}`}
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              {card.title}
            </h3>
            <p
              className="text-[15px] leading-[1.6] text-[#64748B]"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              {card.body}
            </p>
          </div>
        );
      })}
    </div>
  </div>
);

const WhyTeamsAreSwitchingSection = ({ asInnerContent = false }) => {
  if (asInnerContent) {
    return <InnerContent />;
  }
  return (
    <section
      className="w-full flex flex-col items-center py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-[#F4F6F8]"
      style={{ boxSizing: "border-box" }}
    >
      <InnerContent />
    </section>
  );
};

export default WhyTeamsAreSwitchingSection;
